import axios from 'axios';

class Config {
  sources = [];

  async loadServerSideConfig () {
    if (!window.sources) {
      try {
        const response = await axios.get(BASE_API_URL + '/config');
        if (response.status === 200) {
          window.sources = response.data.sources;
        }
      } catch (e) {
      }
    }

    this.sources = JSON.parse(JSON.stringify(window.sources));
  }
}

const singleton = new Config();
export default singleton;

export const BASE_API_URL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:52075/api';



// WEBPACK FOOTER //
// ./src/config.js